import { render, staticRenderFns } from "./ViqCitationPill.vue?vue&type=template&id=5a9a9afc&scoped=true"
import script from "./ViqCitationPill.vue?vue&type=script&lang=js"
export * from "./ViqCitationPill.vue?vue&type=script&lang=js"
import style0 from "./ViqCitationPill.vue?vue&type=style&index=0&id=5a9a9afc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a9afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9a9afc')) {
      api.createRecord('5a9a9afc', component.options)
    } else {
      api.reload('5a9a9afc', component.options)
    }
    module.hot.accept("./ViqCitationPill.vue?vue&type=template&id=5a9a9afc&scoped=true", function () {
      api.rerender('5a9a9afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqCitationPill.vue"
export default component.exports